/**
 * Shared helper functions for AI Weather Agent components.
 *
 * Extracted from AIWeatherAgent.js and TVAIWidget.js to eliminate
 * duplicated logic (~40 lines each).
 */

/**
 * Map alert severity to an emoji icon.
 * @param {string} severity - 'critical' | 'warning' | 'info'
 * @returns {string} emoji
 */
export const getSeverityIcon = (severity) => {
  switch (severity) {
    case 'critical': return '🔴';
    case 'warning': return '🟡';
    case 'info': return '🔵';
    default: return 'ℹ️';
  }
};

/**
 * Map a recommendation string to a contextual emoji icon.
 * @param {string} text - recommendation text
 * @returns {string} emoji
 */
export const getRecIcon = (text) => {
  const lower = text.toLowerCase();
  if (lower.includes('umbrella') || lower.includes('rain')) return '☂️';
  if (lower.includes('hydrat') || lower.includes('water')) return '💧';
  if (lower.includes('layer') || lower.includes('warm') || lower.includes('cold')) return '🧥';
  if (lower.includes('sunscreen') || lower.includes('shade') || lower.includes('sun')) return '☀️';
  if (lower.includes('wind') || lower.includes('secure')) return '💨';
  if (lower.includes('drive') || lower.includes('road') || lower.includes('travel')) return '🚗';
  if (lower.includes('indoor') || lower.includes('shelter')) return '🏠';
  if (lower.includes('ice') || lower.includes('frost')) return '🧊';
  return '💡';
};

/**
 * Format an ISO timestamp to a short local time string (e.g. "2:30 PM").
 * @param {string} ts - ISO 8601 timestamp
 * @returns {string} formatted time or empty string
 */
export const formatTimestamp = (ts) => {
  if (!ts) return '';
  try {
    const d = new Date(ts);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
};

/**
 * Format a dollar amount for display.
 * @param {number|null|undefined} val
 * @returns {string} e.g. "$0.0012"
 */
export const formatCost = (val) => {
  if (val === undefined || val === null) return '$0.00';
  return `$${Number(val).toFixed(4)}`;
};
